import { Controller } from 'react-hook-form';
import Select from 'react-select';

export const DynamicInputMultiSelect = ({
                                            control,
                                            errors,
                                            name,
                                            label,
                                            data,
                                            isRequired = true,
                                            value = 'label',
                                            id = '',
                                            placeholder = '-',
                                            t
                                        }) => {
    return (
        <div className='mb-3'>
            <label htmlFor={name}>{t(label)}</label>
            <Controller
                name={name}
                control={control}
                rules={isRequired ? { required: `${label} is required` } : {}}
                render={({ field }) => {
                    const isBadValue = field.value && !Array.isArray(field.value);

                    return (
                        <>
                            <Select
                                inputId={id}
                                placeholder={t(placeholder)}
                                className={`form-control dynamic-select ${errors[name] ? 'is-invalid' : ''}`}
                                classNames={{
                                    option: () => 'dynamic-select-option',
                                }}
                                options={data}
                                isMulti
                                getOptionValue={(option) => option.value}
                                getOptionLabel={(option) => option[value]}
                                value={
                                    Array.isArray(field.value)
                                        ? data.filter((opt) => field.value.includes(opt.value))
                                        : []
                                }
                                onChange={(val) => field.onChange(val?.map((v) => v.value))}
                                onBlur={field.onBlur}
                            />
                            {isBadValue && (
                                <div className="text-warning mt-1">
                                    ⚠️ {t("Invalid data detected — will be overwritten on save.")}
                                </div>
                            )}
                            {errors?.[name] && (
                                <span className='text-danger'>{errors[name].message}</span>
                            )}
                        </>
                    );
                }}
            />
        </div>
    );
};
